import React from 'react';

const UserFilters = ({ filters, onFilterChange, companies }) => {
  const roleOptions = [
    { value: 'all', label: 'All Roles' },
    { value: 'Admin', label: 'Admin' },
    { value: 'User', label: 'User' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' }
  ];

  const companyOptions = [
    { value: 'all', label: 'All Companies' },
    ...companies?.map(c => ({ value: c?.id, label: c?.name }))
  ];

  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <div className="flex-1">
        <input
          type="text"
          placeholder="Search by name or email..."
          value={filters?.search}
          onChange={(e) => onFilterChange({ ...filters, search: e?.target?.value })}
          className="w-full h-10 px-4 rounded-lg border border-input bg-background focus:outline-none focus:ring-2 focus:ring-ring"
        />
      </div>
      <select
        value={filters?.role}
        onChange={(e) => onFilterChange({ ...filters, role: e?.target?.value })}
        className="h-10 px-4 rounded-lg border border-input bg-background focus:outline-none focus:ring-2 focus:ring-ring"
      >
        {roleOptions?.map(option => (
          <option key={option?.value} value={option?.value}>{option?.label}</option>
        ))}
      </select>
      <select
        value={filters?.company}
        onChange={(e) => onFilterChange({ ...filters, company: e?.target?.value })}
        className="h-10 px-4 rounded-lg border border-input bg-background focus:outline-none focus:ring-2 focus:ring-ring"
      >
        {companyOptions?.map(option => (
          <option key={option?.value} value={option?.value}>{option?.label}</option>
        ))}
      </select>
      <select
        value={filters?.status}
        onChange={(e) => onFilterChange({ ...filters, status: e?.target?.value })}
        className="h-10 px-4 rounded-lg border border-input bg-background focus:outline-none focus:ring-2 focus:ring-ring"
      >
        {statusOptions?.map(option => (
          <option key={option?.value} value={option?.value}>{option?.label}</option>
        ))}
      </select>
    </div>
  );
};

export default UserFilters;